import { inject, Injectable, signal } from '@angular/core';
import { GlobalWebsocketService } from '@approot/global-websocket';
import { sleep } from '@approot/utilities';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class RfqMessagesService {
  public requestId: number;
  public message = signal<Record<string, any>>({});
  private websocketService = inject(GlobalWebsocketService);
  private sub: Subscription = null;

  constructor() {
    this.startListener();
  }

  private startListener() {
    const resubscribe = () => {
      console.log('Starting RfqMessagesService');
      this.sub?.unsubscribe();
      this.sub = this.websocketService
        .getListener({ action: 'apiv2_rfqMessage', take: Infinity })
        .subscribe({
          next: (r: any) => {
            let msg = r.payload?.message;
            if (msg.requestId === this.requestId) {
              const curr = this.message();
              this.message.set({
                ...curr,
                [msg.messageType]: msg
              });
              console.log('RfqMessagesService received message', r);
            }
          },
          complete: async () => {
            console.log('RfqMessagesService subscription completed');
            await sleep(500);
            setTimeout(() => resubscribe());
          },
          error: async err => {
            console.error(err);
            await sleep(500);
            setTimeout(() => resubscribe());
          }
        });
    };

    resubscribe();
  }
}
